var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({
      'font-size': _vm.size+'px',
      'color': _vm.color ? _vm.color + ' !important' : null
    })},[_c('span',{staticClass:"iconify s-icon",attrs:{"data-icon":_vm.icon,"icon":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }